/* eslint-disable no-underscore-dangle */
import Logger from '@sm360/logger-sentry';
import SessionStorageService from 'commons-general/services/SessionStorageService/SessionStorageService.js';
import { ConfigsService, WindowProxy } from '@sm360/widget-commons-core-services';
import { last, isEmpty, isString } from 'lodash';

/**
 * Service to track the user progression accross the widgets
 * Saves the informations has a session storage
 */
class HistoryService {
    constructor() {
        this.HISTORY_KEY_NAME = 'sm360.widget.history';

        this.logger = new Logger('HistoryService', ConfigsService.getLoggerContext());
    }

    /**
     * Returns the URL of the previous page.
     * If the last url in the history is the current page, returns the previous one
     * @param {Array} history
     * @returns {String} url to redirect
     */
    __getUrlofPreviousElement(history) {
        const lastElement = last(history);
        const lastHistoryIsCurrentPage = lastElement && lastElement.url === WindowProxy.location().href;
        if (lastElement && !lastHistoryIsCurrentPage) {
            return lastElement.url;
        } else if (history.length > 1) {
            // Returns to previous page when we have more then 1 element and the first is the current page (usually happens when a refresh happened in the browser)
            return history[history.length - 2].url;
        }

        return null;
    }

    /**
     * Save the given url as a new entry in the history
     * @param {string} url url to add in the history
     * @returns {boolean} if added or not
     */
    add(url) {
        if (!isString(url)) {
            this.logger.error(`Error while adding to history. Param url [${url}] must be a string`);
            return false;
        }
        const newHistory = {
            url,
            timestamp: Date.now(),
        };
        const currentHistory = this.get() || [];

        if (isEmpty(currentHistory) || last(currentHistory).url !== url) {
            currentHistory.push(newHistory);
            SessionStorageService.set(this.HISTORY_KEY_NAME, currentHistory);
            return true;
        }

        this.logger.info(`Did not add new history item. Url [${url}] was already the last item.`);
        return false;
    }

    /**
     * Get the current history navigation in the widgets
     * @returns {array} An array of the history
     */
    get() {
        return SessionStorageService.get(this.HISTORY_KEY_NAME) || [];
    }

    /**
     * Redirects the browser to the last element of the History OR the homepage if the history is empty
     */
    goBackOrHome() {
        const history = this.get();
        const urlToRedirect = this.__getUrlofPreviousElement(history);

        if (isEmpty(history) || !urlToRedirect) {
            WindowProxy.location().href = '/';
            return;
        }

        WindowProxy.location().href = urlToRedirect;
    }
}

export default new HistoryService();
